'use strict'

const registrar = list => fn => {
  list.push(fn)
  return () => {
    const index = list.indexOf(fn)
    if (index >= 0) {
      list.splice(index, 1)
    }
  }
}

module.exports.registrar = registrar



// WEBPACK FOOTER //
// ./recordStore/utils.js